import { api } from '@services';

import Resource, { IResource, IResourceApiModel } from '@models/Resource.model';

interface INewResource {
  label: string;
  uri: string;
  description?: string;
  productIds?: string[];
  manufacturerId?: string;
  haveOwnerStudio?: boolean;
  isGlobal?: boolean;
}
interface IManufacturerVariables {
  data: INewResource;
}

const createResource = async ({
  data,
}: IManufacturerVariables): Promise<IResource> => {
  const { data: resource } = await api.post<IResourceApiModel>(
    `/resources`,
    data,
  );

  return Resource.fromApiModel(resource);
};

export { createResource };
